jQuery(document).ready(function($) {
	
	$('#navclick').click(function(){
		$(this).toggleClass('toggled');
		$('#navContent').toggleClass('open')
	});

	var menuHeight = $(".top-matter").height();
	$(".first-content").css("padding-top", menuHeight);
	$( window ).resize(function() {
	    var menuHeight = $(".top-matter").height();
	    $(".first-content").css("padding-top", menuHeight);
	});

});